import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edis-storungen',
  templateUrl: './edis-storungen.component.html',
  styleUrls: ['./edis-storungen.component.scss'],
})
export class EdisStorungenComponent {
  @Input() url!: string;
  @Input() isIE11 = false;

  constructor(private readonly router: Router) {}

  public gotoDashboard(): void {
    this.router.navigateByUrl('/instrumententafel');
  }
}
